var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tag',{staticClass:"print-background",attrs:{"type":_vm.getPriorityStyle()}},[_vm._v("\n    "+_vm._s(this.getPriorityText())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }